<div class="mx-3 mt-5">
  <div class="row row-cols-1">
    <div class="col form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="generateInvoice"
        [(ngModel)]="generateInvoice"
      />
      <label for="generateInvoice" class="form-check-label text-primary">
        {{ 'Doc::CustomerSubscription:CreateInvoice' | abpLocalization }}
      </label>
    </div>
  </div>

  @if (generateInvoice()) {
    <div class="row row-cols-4">
      <div class="col">
        <label for="invoicingDaybookId" class="form-check-label text-primary">
          {{ 'Doc::DayBook' | abpLocalization }}
        </label>
        <ng-select
          class="form-control"
          id="invoicingDaybookId"
          [(ngModel)]="invoicingDaybookId"
          bindLabel="name.current"
          bindValue="id"
          [items]="dayBooks"
          [clearable]="false"
        ></ng-select>
      </div>
      <div class="col">
        <label for="invoicingPrintTemplateId" class="form-check-label text-primary">
          {{ 'Doc::DayBook:PrintTemplates' | abpLocalization }}
        </label>
        <ng-select
          class="form-control"
          id="invoicingPrintTemplateId"
          [(ngModel)]="invoicingPrintTemplateId"
          bindLabel="name"
          bindValue="id"
          [dwApiSelect]="printTemplateSelect"
          [clearable]="false"
        ></ng-select>
      </div>
    </div>

    <div class="row row-cols-1">
      <div class="col form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="sendInvoice"
          [(ngModel)]="sendInvoice"
        />
        <label for="sendInvoice" class="form-check-label text-primary">
          {{ 'Doc::CustomerInvoice:SendEmail' | abpLocalization }}
        </label>
      </div>
    </div>

    @if (sendInvoice()) {
      <div class="row row-cols-4">
        <div class="col">
          <label for="invoiceEmailTemplateId" class="form-check-label text-primary">
            {{ 'Doc::DayBook:TextTemplate' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="invoiceEmailTemplateId"
            [(ngModel)]="invoiceEmailTemplateId"
            bindLabel="name"
            bindValue="id"
            [items]="textTemplates"
            [clearable]="false"
          ></ng-select>
        </div>
      </div>
    }
  }
</div>
